import { Connector } from 'wagmi';

import { SET_ADDRESS, SET_CHAIN_ID, SET_CONNECTOR } from '@/shared/store/wagmi/constants';

type State = {
    connector: Connector | null;
    address: string | null;
    chainId: string | null;
};

const initialState: State = {
    connector: null,
    address: null,
    chainId: null,
};

const wagmiWalletReducer = (state = initialState, action: any): State => {
    switch (action.type) {
        case SET_CONNECTOR:
            return { ...state, connector: action.payload };
        case SET_ADDRESS:
            return { ...state, address: action.payload };
        case SET_CHAIN_ID:
            return { ...state, chainId: action.payload };
        default:
            return state;
    }
};

export default wagmiWalletReducer;
